import {
    DISBURSEMENTREQUEST_SUCCESSFUL_GET,
    DISBURSEMENTREQUEST_UPDATE_FILTERSTATUS,
    DISBURSEMENTREQUEST_UPDATE_FILTERSTARTDATE,
    DISBURSEMENTREQUEST_UPDATE_FILTERENDDATE,
    DISBURSEMENTREQUEST_SUCCESSFUL_INFO_GET,
    DISBURSEMENTREQUEST_SUCCESSFUL_HISTORY_GET,
    DISBURSEMENTREQUEST_SUCCESSFUL_ANNULMENT
} from 'reducers/constants';

const initialState = {
    data: null,
    filterStatus: null,
    filterStartDate: "",
    filterEndDate: "",
    info: null,
    history: []
}

export default function (state = initialState, action) {
    switch (action.type) {

        case DISBURSEMENTREQUEST_SUCCESSFUL_GET:
            return {
                ...state,
                data: Object.assign({}, action.payload)
            }

        case DISBURSEMENTREQUEST_UPDATE_FILTERSTATUS:
            return {
                ...state,
                filterStatus: action.payload != null ? action.payload : null
            }

        case DISBURSEMENTREQUEST_UPDATE_FILTERSTARTDATE:
            return {
                ...state,
                filterStartDate: action.payload != "" ? action.payload : ""
            }

        case DISBURSEMENTREQUEST_UPDATE_FILTERENDDATE:
            return {
                ...state,
                filterEndDate: action.payload != "" ? action.payload : ""
            }

        case DISBURSEMENTREQUEST_SUCCESSFUL_INFO_GET:
            return {
                ...state,
                info: Object.assign({}, action.payload)
            }

        case DISBURSEMENTREQUEST_SUCCESSFUL_HISTORY_GET:
            return {
                ...state,
                history: action.payload.slice()
            }

        case DISBURSEMENTREQUEST_SUCCESSFUL_ANNULMENT:
            return {
                ...state,
                history: action.payload.slice()
            }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/disbursementrequest/disbursementrequestReducer.js